import { useCallback, useState } from "react";

const useLoadImage = (image) => {
  const [imageSrc, setImageSrc] = useState();

  const loadImage = useCallback(() => {
    if (image) {
      const src = URL.createObjectURL(image);
      setImageSrc(src);
      return () => {
        URL.revokeObjectURL(src);
      };
    } else {
      setImageSrc(null);
    }
  }, [image]);

  return { imageSrc, loadImage };
};

export default useLoadImage;
